// Mobilní hlavička — drobnosti, které nativní DOM nemá a nepatří k draweru
// (mobileNav.js) ani k fullscreen hledání (mobileSearch.js):
//   - ikona do hamburgeru (blank mode mu vzal glyf) + tmavé kolečko kolem,
//   - lupa do sticky řádku (search řádek po scrollu odjede, m01-header.md §3),
//   - × do nativního login panelu (klik mimo ho nezavírá a ESC na mobilu není).
// Idempotentní.
//
// POZOR stacking: #navigation žije v #header → drawer vyžaduje zvednout celý
// header; admin bar drawer+10, panely drawer+20 (bug viditelný JEN pro admina).

import { icon } from './icon.js';
import { openMobileSearch } from './mobileSearch.js';
import L from '../locale/cs/mobileHeader.js';

const LABEL_MENU = L.menu;
const LABEL_SEARCH = L.search;
const LABEL_CLOSE = L.close;

export function initMobileHeader() {
  // hamburger: nativní `a.toggle-window[data-target=navigation]` je v blank módu
  // prázdný <a> — dodáme mu tmavé kolečko s ikonou. Klik obsluhuje mobileNav.js.
  const navToggle = document.querySelector(
    '#header .navigation-buttons a.toggle-window[data-target="navigation"]'
  );
  if (navToggle && !navToggle.querySelector('.bs-burger-icon')) {
    const circle = document.createElement('span');
    circle.className = 'bs-burger-icon';
    circle.appendChild(icon('menu'));
    navToggle.appendChild(circle);
    navToggle.setAttribute('aria-label', LABEL_MENU);
  }

  // lupa vedle ostatních ikon — viditelná až po scrollu, kdy odjede search řádek
  const navButtons = document.querySelector('#header .navigation-buttons');
  if (navButtons && !navButtons.querySelector('.bs-search-toggle')) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bs-search-toggle';
    btn.setAttribute('aria-label', LABEL_SEARCH);
    btn.appendChild(icon('search'));
    btn.addEventListener('click', openMobileSearch);
    navButtons.prepend(btn);
  }

  // Login panel nemá nativní zavírání dotykem: klik mimo nezavírá, ESC na mobilu
  // není a panel překrývá toggle ikonu → injektujeme ×, klik delegujeme na
  // nativní toggle (default JS si drží stav přes body třídy).
  const loginInner = document.querySelector('.user-action-login .popup-widget-inner');
  if (loginInner && !loginInner.querySelector('.bs-login-close')) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bs-login-close';
    btn.setAttribute('aria-label', LABEL_CLOSE);
    btn.addEventListener('click', function () {
      const toggle = document.querySelector('.top-nav-button-login')
        || document.querySelector('[data-target="login"]');
      if (toggle) toggle.click();
    });
    loginInner.prepend(btn);
  }
}
